import { useMutation, useQueryClient } from "@tanstack/react-query"
import { axiosInstance } from "@/api/axios"
import { PeriodTypeView } from "@/types"
import { createQueryKey, EXPORT } from "@/api/query-keys"

type ExportEcommerceModule =
  | "profit-and-loss"
  | "personnel"
  | "cogs"
  | "opex"
  | "oic"
  | "revenues"
  | "twc"
  | "vat"
  | "all"
  | "fixed-assets"
  | "provisions"
  | "owc"
  | "capital-structure"
  | "taxes"
export type ExportFormat = "xlsx" | "pdf"

type Options = {
  module: ExportEcommerceModule
  view: PeriodTypeView
}

export type ExportEcommerceModuleProps = {
  financialModelId: string
  options: Options
}

export const exportEccomerceModule = async ({
  financialModelId,
  options,
  format,
}: ExportEcommerceModuleProps & { format: ExportFormat }) => {
  const response = await axiosInstance.get(
    `/excel/total-results/${financialModelId}/${options.module}`,
    {
      params: {
        output: format,
        view: options.view,
      },
      responseType: `blob`,
    }
  )
  return response.data
}

const EXPORT_ECOMMERCE_MODULE_KEY = createQueryKey({
  baseKey: EXPORT,
  keys: [`ecommerce`],
})

export const useExportEcommerceModule = (
  props: ExportEcommerceModuleProps & { format: ExportFormat }
) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => exportEccomerceModule(props),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EXPORT_ECOMMERCE_MODULE_KEY })
    },
  })
}
